import React, { memo } from "react";

import { Grid, Typography } from "@mui/material";

function LineInfo() {
  return (
    <Grid xs={12} style={{ marginLeft: "0.25em" }}>
      <Grid
        container
        justifyContent="flex-start"
        direction="row"
        // spacing={1}
      >
        <Typography variant="body2">
          Du willst für deine Klasse Hausaufgaben und Prüfungen eintragen?
          <br />
          Kontaktiere husibuech.ch und werde Referenzschüler*in (info@ksb-it.ch)
        </Typography>
      </Grid>
    </Grid>
  );
}

export default memo(LineInfo);
